module.exports = __webpack_public_path__ + "static/img/bac.6fdac177.png";